export default __webpack_public_path__ + "static/media/cropped_image.dcd9cf11.png";